export const HOST_DETAILS_PATH = '/experimental/hosts/:id';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/HostDetails/constants.js